module.exports = __webpack_public_path__ + "img/89.2.TN.ca72281b.png";